import { useTranslation } from "@sagot/i18n";
import { useMemo } from "react";
import { z } from "zod";
import { EXPIRY_CHOICES, type ExpiryChoice } from "./gap-model";

export const ANSWER_MAX_CHARS = 20_000;

export interface AnswerValues {
  answer: string;
  audience: string;
  expiry: ExpiryChoice;
  customDate: string;
  agentIds: string[];
}

const todayIso = () => new Date().toISOString().slice(0, 10);

/** Write-answer form schema (messages localized). */
export function useAnswerSchema() {
  const { t } = useTranslation();
  return useMemo(
    () =>
      z
        .object({
          answer: z.string().trim().min(1, t("engage.gaps.sheet.answerRequired")).max(ANSWER_MAX_CHARS),
          audience: z.string(),
          expiry: z.enum(EXPIRY_CHOICES as [ExpiryChoice, ...ExpiryChoice[]]),
          customDate: z.string(),
          agentIds: z.array(z.string()).min(1, t("engage.gaps.sheet.agentsRequired")),
        })
        .refine((v) => v.expiry !== "custom" || v.customDate > todayIso(), {
          path: ["customDate"],
          message: t("engage.gaps.sheet.customDateRequired"),
        }),
    [t],
  );
}
